const NumberUtil = {
  round(number, precision = 0) {
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }
};

export default NumberUtil;
